import { apiRequest } from './apiService';

export const REPORT_STATUSES = ['open', 'reviewing', 'resolved', 'dismissed'];
export const OFFENCE_STATUSES = REPORT_STATUSES;

export const REPORT_REASONS = {
  harassment: 'Harassment',
  spam_or_scam: 'Spam or scam',
  inappropriate_content: 'Inappropriate content',
  payment_or_off_platform_pressure: 'Payment or off-platform pressure',
  safety_concern: 'Safety concern',
  other: 'Other'
};

const normalizeReport = (report) => ({
  id: report.id,
  conversationId: report.conversationId || '',
  artistUid: report.artistUid || '',
  collectorUid: report.collectorUid || '',
  artworkId: report.artworkId || '',
  artworkTitle: report.artworkTitle || 'Untitled artwork',
  reason: report.reason || 'other',
  notes: report.notes || '',
  status: report.status || 'open',
  blockScope: report.blockScope || 'artist',
  messageContext: Array.isArray(report.messageContext) ? report.messageContext : [],
  createdAt: report.createdAt || null,
  updatedAt: report.updatedAt || null,
  reviewedAt: report.reviewedAt || null,
  reviewedBy: report.reviewedBy || ''
});

const normalizeOffence = (offence) => ({
  id: offence.id,
  source: offence.source || 'conversation_message',
  decision: offence.decision || 'blocked',
  status: offence.status || 'open',
  senderUid: offence.senderUid || '',
  senderRole: offence.senderRole || 'participant',
  conversationId: offence.conversationId || '',
  artistUid: offence.artistUid || '',
  collectorUid: offence.collectorUid || '',
  artworkId: offence.artworkId || '',
  artworkTitle: offence.artworkTitle || 'Untitled artwork',
  messageText: offence.messageText || '',
  matches: Array.isArray(offence.matches) ? offence.matches : [],
  categories: Array.isArray(offence.categories) ? offence.categories : [],
  createdAt: offence.createdAt || null,
  updatedAt: offence.updatedAt || null,
  reviewedAt: offence.reviewedAt || null,
  reviewedBy: offence.reviewedBy || ''
});

export const fetchReportedConversations = async ({ status = 'all' } = {}) => {
  const params = new URLSearchParams({ limit: '200' });
  if (status && status !== 'all') {
    params.set('status', status);
  }

  const reports = await apiRequest(`/admin/collector-reports?${params.toString()}`);
  return reports.map(normalizeReport);
};

export const updateReportedConversationStatus = async (reportId, status) => {
  if (!reportId) {
    throw new Error('Report ID is required.');
  }
  if (!REPORT_STATUSES.includes(status)) {
    throw new Error('Invalid report status.');
  }

  await apiRequest(`/admin/collector-reports/${encodeURIComponent(reportId)}/status`, {
    method: 'PATCH',
    body: { status }
  });
};

export const fetchMessageModerationOffences = async ({ status = 'all' } = {}) => {
  const params = new URLSearchParams({ limit: '200' });
  if (status && status !== 'all') {
    params.set('status', status);
  }

  const offences = await apiRequest(`/admin/message-moderation-offences?${params.toString()}`);
  return offences.map(normalizeOffence);
};

export const updateMessageModerationOffenceStatus = async (offenceId, status) => {
  if (!offenceId) {
    throw new Error('Offence ID is required.');
  }
  if (!OFFENCE_STATUSES.includes(status)) {
    throw new Error('Invalid offence status.');
  }

  await apiRequest(`/admin/message-moderation-offences/${encodeURIComponent(offenceId)}/status`, {
    method: 'PATCH',
    body: { status }
  });
};
